interface ContentPreloaderProps {
  background?: string;
  zIndex?: number;
}

const ContentPreloader: React.FC<ContentPreloaderProps> = (props) => {
  return (
    <div
      className="raul-content-loader-wrapper"
      style={{
        background: props.background || 'rgba(255,255,255,.75)',
        zIndex: props.zIndex === 0 ? 0 : props.zIndex || 50,
      }}
    >
      <div className="raul-content-loader"></div>
    </div>
  );
};

export default ContentPreloader;
